import { render, staticRenderFns } from "./EdWangEditor.vue?vue&type=template&id=61bcc8a6&scoped=true&"
import script from "./EdWangEditor.vue?vue&type=script&lang=js&"
export * from "./EdWangEditor.vue?vue&type=script&lang=js&"
import style0 from "./EdWangEditor.vue?vue&type=style&index=0&id=61bcc8a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61bcc8a6",
  null
  
)

export default component.exports